import { InspectionTypeEnum } from "./enums/inspection-type.enum";

export default class Inspection {
  public plate: string = '';

  public chassis: string;

  public cellphone: string = '';

  public name: string = '';

  public apiToken: string = '';

  public notes: string = '';

  public cpf: string = '';

  public cnpj: string = '';

  public email: string = '';

  public transactionId: string = '';

  public isAgriculturalMachinery: boolean;

  public inspectionId: string;

  constructor(data: any = {}) {
    this.plate = data.plate || '';
    this.cellphone = data.cellphone || '';
    this.apiToken = data.api_token;
    this.notes = data.notes || '';
    this.name = data.name || '';
    this.cpf = data.cpf || '';
    this.cnpj = data.cnpj || '';
    this.email = data.email || '';
    this.transactionId = data.transaction_id || '';
    this.isAgriculturalMachinery = data.is_agricultural_machinery || false;
    this.chassis = data.chassis || '';
    this.inspectionId = data.inspection_id || '';
  }

  private selectedType: string = localStorage.getItem('inspection-type') || '';

  public formatPayload(): any {
    const obj: any = {
      cpf: this.cpf.replace(/[-.]/g, ''),
      name: this.name,
      email: this.email,
      cellphone: this.cellphone.replace(/[()-]/g, '').replace(' ', ''),
      is_agricultural_machinery: !!(this.selectedType === InspectionTypeEnum.AGRICULTURAL_MACHINE)
    };

    if (this.plate && this.plate.length === 7) {
      obj.plate = this.plate;
    }

    if (this.chassis) {
      obj.chassis = this.chassis;
    }

    if (this.plate && this.plate.length === 17) {
      obj.chassis = this.plate;
    }

    if (this.inspectionId) {
      obj.inspection_id = this.inspectionId;
    }

    return obj;
  }
}
